<template>
  <div class="form-page">
    <div class="tooltip" v-if="history[currentStep].field.tooltip">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text" v-html="history[currentStep].field.tooltip">
      </p>
    </div>
    <!-- one input -->
    <div
      :class="[
        'form-input__wrap',
        ibanClass,
        {'secure-iban-error': history[currentStep].name === 'bank_account_number' && (history[currentStep].showError || invalidFromBackend)}]">
      <input
        v-if="showInput"
        :type="inputType"
        :inputmode="(showCurrency || inputType === 'tel') ? 'number' : 'string'"
        class="form-input"
        v-model="inputVal"
        @keyup="handleKeyup"
        @change="handleChange"
        :name="history[currentStep].name"
        v-bind:class="{error: history[currentStep].showError || invalidFromBackend}"
        :placeholder="placeholder"
        required>
      <span
        class="form-input-floating-label"
        v-bind:class="{error: history[currentStep].showError || invalidFromBackend}"
      >
        <img v-if="history[currentStep].name === 'bank_account_number' && newDesign" :src="`https://cdn.crezu.net/game_flow/src/assets/img/${country === 2 ? 'clabe' : 'iban'}.svg`"/>
        {{history[currentStep].field.label}}
      </span>
      <span v-if="showCurrency" class="form-input__after">{{config.params.currency}}</span>
      <span
        v-if="history[currentStep].name === 'bank_account_number' && newDesign"
        class="form-input__mark"
      >
        <transition name="fade">
          <img
            v-if="history[currentStep].isValid"
            src="https://cdn.crezu.net/game_flow/src/assets/img/valid_new.svg" alt="">
        </transition>
        <transition name="fade">
          <img
            v-if="history[currentStep].showError || invalidFromBackend"
            src="https://cdn.crezu.net/game_flow/src/assets/img/invalid_new.svg"
            alt=""
          >
        </transition>
      </span>
<!--      <transition name="fade"><div v-if="showEmailHint" class="form-input__wrap-note email-hint">{{emailHintText}} <a @click="replaceDomain">@{{predictedEmailDomain}}</a> ?</div></transition>-->
    </div>
    <transition name="fade">
      <span class="error-message" v-if="history[currentStep].showError || invalidFromBackend">
        {{history[currentStep].field.error}}
      </span>
    </transition>
    <div v-if="history[currentStep].name === 'bank_account_number' && +country === 1">
      <div v-if="ibanNotCCC">Si prefieres con tu número de cuenta click <a @click="ibanToCCC" style="cursor: pointer">aquí</a></div>
      <div v-else>Si prefieres mediante IBAN, haz click <a @click="cccToIban" style="cursor: pointer">aquí</a></div>
    </div>
    <div class="clabe-additional" v-if="history[currentStep].name === 'bank_account_number' && +country === 2">
      <div style="display: inline-flex; cursor: pointer" @click="showCLABEAdditional = !showCLABEAdditional"><span style="display: flex;font-weight: bold">¿Dónde puedo ver mi CLABE?</span><div class="arrow_CLABE" :class="{opened : showCLABEAdditional}"></div></div>
      <transition name="fade"><div v-if="showCLABEAdditional"><br><span style="font-weight: bold">- Si tienes BBVA puedes solicitar tu CLABE fácilmente enviando la palabra CLABE al 266845. *Si aún no cuentas con el servicio de SMS de Bancomer será necesario enviar primero ALTA al 266845.</span><br><br><span style="font-weight: bold">- En todos tus estados de cuenta:</span> impresos o en línea. La CLABE generalmente se encuentra en la esquina superior derecha del estado de cuenta, justo al lado de tu RFC y número de cuenta. Generalmente se trata del código más largo, siempre de 18 dígitos, así puedes diferenciarlo.<br><br><span style="font-weight: bold">- En Tu perfil de banco en línea:</span> Cuando ingreses a tu banco en línea o móvil, dirígete a las opciones o detalles del perfil. Allí encontrarás la CLABE y otros datos personales.<br><br><span style="font-weight: bold">-Línea Directa:</span> Si por alguna razón no tienes acceso a las opciones anteriores, o no has podido hallar la respuesta, recuerda que siempre puedes telefonear o chatear con el servicio al cliente de tu banco o acudir a tu directamente a una sucursal o cajero.</div></transition>
      <div class="clabe-skip-container"><a style="cursor: pointer;" @click="skipCLABE">Haz clic aquí si no tienes una cuenta bancaria (CLABE)</a></div>
    </div>
    <div v-if="history[currentStep].name === 'bank_account_number' && +country === 7" class="skip-iban__ua">
      <div><a @click="skipUAPassportSteps">{{
          (langFromLS === 'ru') ? 'Нажмите здесь, если у вас отсутствуют данные паспорта или индивидуального налогового номера (ИНН)' : 'Натисніть тут, якщо у вас немає даних паспорти або ідентифікаційного податкового номера (IПН)'
        }}</a></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Inputmask from 'inputmask'
import { CCCToIBAN } from '../../helpers'
import { validatePolish } from 'validate-polish'
const ibantools = require('ibantools')

export default {
  name: 'SimpleInput',
  components: { InfoIcon },
  data () {
    return {
      inputVal: '',
      showCLABEAdditional: false,
      emailCheckTimeout: 1500,
      delayTmut: null,
      ibanNotCCC: true,
      im: {},
      langFromLS: localStorage.getItem('lang'),
      newDesign: window.newDesign
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      showInput: state => state.showInput,
      config: state => state.config,
      provider: state => state.additionalParams.provider,
      country: state => state.additionalParams.country,
      mask: state => state.history[state.currentStep].field['game-mask'],
      showCurrency: state => ['other_loans_amount', 'income_amount', 'monthly_expenses'].indexOf(state.history[state.currentStep].name) > -1,
      fieldName: state => state.history[state.currentStep].name,
      field: state => state.history[state.currentStep],
      predictedEmailDomain: state => state.predictedEmailDomain
    }),
    isValid () {
      const val = this.inputVal
      console.log(ibantools.isValidIBAN(val.split(' ').join('')))
      const regex = new RegExp(this.history[this.currentStep].field.reg, 'gi')
      if (+this.country === 14 && this.field.name === 'pesel') return validatePolish.pesel(val)
      if (+this.country === 14 && this.field.name === 'bank_account_number') return ibantools.isValidIBAN(val.split(' ').join(''))
      if (this.isCCC && this.isCCCValid) return true
      return regex.test(val)
    },
    invalidFromBackend () {
      let result = false
      let values = this.history[this.currentStep].invalidValues
      if (values && values.indexOf(this.inputVal) > -1) result = true
      return result
    },
    isCCC () {
      return this.fieldName === 'bank_account_number' && this.country === 1 && !this.ibanNotCCC
    },
    isCCCValid () {
      return this.inputVal.split(' ').join('').length === 20 && this.inputVal.indexOf('_') === -1
    },
    placeholder () {
      let placeholder = this.field.field.placeholder
      if (this.isCCC) placeholder = '_____________________'
      return placeholder
    },
    inputType: function () {
      let type = this.field.field.type
      if (this.fieldName === 'zip') type = 'tel'
      if (this.fieldName === 'email') type = 'email'
      return type
    },
    showEmailHint: function () {
      return this.fieldName === 'email' && this.predictedEmailDomain
    },
    emailHintText: function () {
      return (this.field.field && this.field.field.emailHintText) ? this.field.field.emailHintText : 'Tal vez querías escribir'
    },
    ibanClass: function () {
      if (this.fieldName === 'bank_account_number') {
        if (+this.country === 14) return 'iban-pl'
        if (this.newDesign) return ''
        return 'secure-iban'
      }
      return ''
    }
  },
  mounted () {
    if (this.mask) this.addMask(this.mask)
    this.inputVal = this.history[this.currentStep].value || ''
    if (this.fieldName === 'email') {
      localStorage.setItem('emailHistory', '')
    }
    if (this.mask) this.updateValue()
  },
  watch: {
    inputVal: function (val) {
      if (this.showCurrency) val = val.split(' ').join('')
      if (this.isCCC) val = CCCToIBAN(val.split(' ').join(''), 'ES')
      this.$store.commit('UPDATE_FIELD', {isValid: this.isValid, value: val})
      if (this.history[this.currentStep].name === 'email') {
        localStorage.setItem('email', val)
        if (val.indexOf('@') > -1) localStorage.setItem('domain', val.split('@')[1])
      }
    },
    showInput: function (val, oldVal) {
      if (val && this.mask) {
        this.$nextTick(() => {
          let mask = this.mask
          if (this.isCCC) mask = '99999999999999999999'
          this.addMask(mask)
        })
      }
    }
  },
  methods: {
    handleKeyup (e) {
      if (this.history[this.currentStep].name === 'email') {
        // TODO: delete AB test event
        // if ((['crezu.mx'].indexOf(window.location.hostname) > -1 && window.location.pathname === '/reg2/') || window.location.hostname === 'localhost') this.checkEmailDomain()
        this.inputVal = this.inputVal.toLowerCase()
      }
      if (this.history[this.currentStep].name === 'id_number') {
        this.inputVal = this.inputVal.toUpperCase()
      }
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    },
    handleChange (e) {
      this.inputVal = e.target.value
    },
    skipCLABE () {
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: 'IGNORE', skip: true })
      this.$store.dispatch('nextStepPrepare', +1)
    },
    skipUAPassportSteps () {
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: 'IGNORE', skip: true })
      this.$store.dispatch('insertOrUpdateField', {
        index: this.currentStep + 1,
        data: { name: 'id_number', isValid: true, value: 'IGNORE', skip: true }
      })
      this.$store.dispatch('nextStepPrepare', +1)
    },
    addMask (mask) {
      return new Promise(resolve => {
        if (this.im.remove) this.im.remove()
        const options = {
          positionCaretOnClick: 'radixFocus',
          showMaskOnHover: false
        }
        if (this.newDesign) options.placeholder = this.field.field.placeholder
        this.im = new Inputmask(mask, options)
        setTimeout(() => {
          this.im.mask(document.getElementsByName(this.history[this.currentStep].name)[0])
          resolve()
        }, 50)
      })
    },
    replaceDomain () {
      this.inputVal = this.inputVal.split('@')[0] + '@' + this.predictedEmailDomain
      this.$store.commit('CHANGE_PREDICTED_EMAIL_DOMAIN', '')
    },
    checkEmailDomain () {
      this.$store.commit('CHANGE_PREDICTED_EMAIL_DOMAIN', '')
      clearTimeout(this.delayTmut)
      this.delayTmut = setTimeout(() => {
        let domain = ''
        if (this.inputVal.indexOf('@') > -1) domain = this.inputVal.split('@')[1]
        if (domain) this.$store.dispatch('checkEmailDomain', domain)
      }, this.emailCheckTimeout)
    },
    async ibanToCCC () {
      await this.addMask('99999999999999999999')
      let val = this.inputVal.split(' ').join('')
      if (val.length === 24 && this.inputVal.indexOf('_') === -1) {
        this.inputVal = val.slice(4, val.length)
      } else {
        this.inputVal = ''
      }
      this.updateValue()
      this.ibanNotCCC = false
    },
    async cccToIban () {
      await this.addMask(this.mask)
      let val = this.inputVal.split(' ').join('')
      if (val.length === 20) {
        this.inputVal = CCCToIBAN(val, 'ES')
      } else {
        this.inputVal = ''
      }
      this.updateValue()
      this.ibanNotCCC = true
    },
    updateValue () {
      // feature for get new value after inserting data and updating with inputmask
      setTimeout(() => {
        let selector = document.getElementsByName(this.history[this.currentStep].name)[0]
        if (selector) this.inputVal = selector.value
      }, 150)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/inputs";
</style>



// WEBPACK FOOTER //
// src/components/fields/SimpleInput.vue